

























import Vue from 'vue';

import DialogCard from '@/components/DialogCard.vue';

export default Vue.extend({
  components: {
    DialogCard
  },

  props: {
    // One of: 'small', 'x-small'
    size: {
      type: String,
      default: 'small'
    }
  },

  data() {
    return {
      open: false
    };
  },

  methods: {
    openDialog() {
      this.open = true;
    },

    closeDialog() {
      this.open = false;
    }
  }
});
